import React, { useEffect, useId, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import useGearCatalog from '../gear/useGearCatalog';
import { searchSuggestions } from '../../domain/siteSearch';
import useSearchPages from './useSearchPages';
import './SiteSearch.css';

export default function SiteSearch({ hero = false }) {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(-1);
  const { products, loading } = useGearCatalog();
  const { pages } = useSearchPages(query);
  const results = searchSuggestions(products, pages, query);
  const navigate = useNavigate();
  const location = useLocation();
  const id = useId();
  const root = useRef(null);
  const show = open && query.trim().length >= 2;
  useEffect(() => { setOpen(false); setActive(-1); }, [location.pathname, location.search]);
  const searchUrl = `/search?q=${encodeURIComponent(query.trim())}`;
  function submit(event) {
    event.preventDefault();
    if (!query.trim()) return;
    navigate(active >= 0 && results[active] ? results[active].path : searchUrl);
    setOpen(false);
  }
  return <div className={`ab-site-search${hero ? ' ab-site-search--hero' : ' ab-site-search--header'}`} ref={root} onBlur={e => { if (!e.currentTarget.contains(e.relatedTarget)) setOpen(false); }}>
    <form role="search" aria-label="Search Angler Built" onSubmit={submit}>
      <label className="ab-search-sr" htmlFor={id}>Search products and pages</label>
      <input id={id} type="search" role="combobox" aria-expanded={show} aria-controls={`${id}-results`} aria-autocomplete="list" aria-activedescendant={active >= 0 && show ? `${id}-${active}` : undefined} autoComplete="off" placeholder={hero ? 'Search gear, guides & more' : 'Search gear & pages'} value={query} onChange={e => { setQuery(e.target.value); setOpen(true); setActive(-1); }} onFocus={() => setOpen(true)} onKeyDown={e => {
        if (e.key === 'Escape') { setOpen(false); setActive(-1); }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); setOpen(true); setActive(i => results.length ? (i + (e.key === 'ArrowDown' ? 1 : -1) + results.length) % results.length : -1); }
      }}/>
      <button type="submit" aria-label="Search"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 5 5"/></svg></button>
    </form>
    {show && <div className="ab-search-dropdown">
      <ul id={`${id}-results`} role="listbox" aria-label="Suggested products and pages">
        {results.map((r, i) => <li key={r.path} id={`${id}-${i}`} role="option" aria-selected={active === i}><Link to={r.path} onClick={() => setOpen(false)}><span>{r.title}</span><small>{r.type}</small></Link></li>)}
      </ul>
      {!results.length && <p>{loading ? 'Loading products…' : 'No matches yet. Try another product or brand.'}</p>}
      <Link className="ab-search-all" to={searchUrl} onClick={() => setOpen(false)}>See all results <span aria-hidden="true">→</span></Link>
    </div>}
  </div>;
}
